




  import React, { useState, useEffect } from 'react';
  import {
    Box, Button, Card, CardContent, Container, Typography, IconButton,  
    AppBar, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Paper, Grid, Chip, TextField,Stepper,Step,StepLabel,
    Alert, MenuItem
  } from '@mui/material';
  import {
    ArrowBack, PhotoLibrary, Close, CheckCircle, 
    LocalHospital, Person
  } from '@mui/icons-material';
  import uploadPrescription from '../Logos/upload_prescription/upload_prescription.png'
  import paymentMethod from '../Logos/upload_prescription/payment_method.png'
  import uploadGuidelines from '../Logos/upload_prescription/upload_guidelines.png'
  import CustomDialog from "../../CustomDialog";
  import addressConfig from "../../Configurations/addressConfig.json";
  import PatientDetailsForm from './PatientDetailsForm';
  import { apiRequest } from '../../fetchSetup';
  import axios from 'axios';
  
  const COMMUNITY_OPTIONS = addressConfig.communities;
  const BLOCK_OPTIONS = addressConfig.blocks;
  

  // Add this after the BLOCK_OPTIONS constant
const DELIVERY_TIME_CONFIG = {
  minHoursFromNow: 2, // Minimum hours from current time
  timeSlotInterval: 30, // Minutes between each time slot
  availableHoursRange: [6, 22], // Available hours (6 AM to 10 PM)
  daysToShow: 10 // Number of days to show slots for
};



  // Updated function to upload prescriptions to backend
  const uploadPrescriptionToServer = async (files, orderId) => {
    const formData = new FormData();
    
    // Append order ID
    formData.append('order_id', orderId);
    
    // Append each file
    files.forEach((fileObj) => {
      if (fileObj.file) {
        formData.append('prescriptions', fileObj.file);
      }
    });
    
    try {
      const token = sessionStorage.getItem("token");
      // const response = await axios.post(`${process.env.REACT_APP_PRESCRITON_MEDICINE_API_URL}`, formData);
      const response = await axios.post(
        `${process.env.REACT_APP_PRESCRITON_MEDICINE_API_URL}`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,  
            "Content-Type": "multipart/form-data",
          }
        }
      );
      
      if (!response.data) {
        throw new Error('Failed to upload prescriptions');
      }
      
      const result = await response.data;
      // Returns: { prescription_urls: ['/prescriptions/ORD123_0.jpg', ...] }
      return result.prescription_urls;
    } catch (error) {
      console.error('Error uploading prescriptions:', error);
      throw error;
    }
  };


  const createPrescriptionOrder = async (orderData) => {
    const response = await apiRequest(`${process.env.REACT_APP_MEDICINE_API_URL}/medicine-orders`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(orderData)
    });
    
    if (!response.ok) {
      throw new Error('Failed to create order');
    }
    
    return response.json();
  };
  
  // Main Component
  const PrescriptionUploadScreen = () => {
    const [step, setStep] = useState('patient');
    const [prescriptionFiles, setPrescriptionFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
    const [fileToRemove, setFileToRemove] = useState(null);
    const [loading, setLoading] = useState(false);
    const [patientDetails, setPatientDetails] = useState(null);
    const [deliveryTimeOption, setDeliveryTimeOption] = useState('anytime');
    const [selectedDateForSlot, setSelectedDateForSlot] = useState('');
    const [deliveryTimeSlots, setDeliveryTimeSlots] = useState([]);
    const [selectedDeliveryTimeSlot, setSelectedDeliveryTimeSlot] = useState('');
    const [dialog, setDialog] = useState({ 
      open: false, 
      message: "", 
      title: "",
      type: "info" 
    });
    
    const [address, setAddress] = useState({
      full_name: '',
      phone: '',
      community_name: '',
      address_line1: '',
      address_line2: '',
      landmark: '',
      city: '',
      state: '',
      pincode: '',
      address_type: 'home'
    });
  
    const [order, setOrder] = useState(null);
    const [user, setUser] = useState(null);
    const [emailError, setEmailError] = useState("");
  
useEffect(() => {
  const loadAddressFromPhone = async () => {
    // Check if patientDetails has phone number
    if (patientDetails && patientDetails.phone) {
      try {
        const token = sessionStorage.getItem("token");
        const apiUrl = process.env.REACT_APP_GET_USER_BY_PHONE_API;
        
        //  Clean the phone number
        let cleanedPhone = patientDetails.phone.trim();
        if (cleanedPhone.startsWith('+91')) {
          cleanedPhone = cleanedPhone.substring(3);
        } else if (cleanedPhone.startsWith('91') && cleanedPhone.length === 12) {
          cleanedPhone = cleanedPhone.substring(2);
        }
        cleanedPhone = cleanedPhone.replace(/[\s-]/g, '');
        
        const response = await apiRequest(`${apiUrl}/${cleanedPhone}`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.user) {
            console.log('✅ User found, loading address:', data.user);
            
            // ✅ Pre-fill address from user data
            if (data.user.address) {
              setAddress({
                full_name: data.user.address.full_name || data.user.name || patientDetails.name || '',
                email:data.user.email || data.user.user_email,
                phone: data.user.address.phone || data.user.phone || patientDetails.phone || '',
                community_name: data.user.address.community_name || '',
                address_line1: data.user.address.address_line1 || '',
                address_line2: data.user.address.address_line2 || '',
                landmark: data.user.address.landmark || '',
                city: data.user.address.city || '',
                state: data.user.address.state || '',
                pincode: data.user.address.pincode || '',
                address_type: data.user.address.address_type || 'home'
              });
              console.log('✅ Address pre-filled from database');
            } else {
              // User found but no address saved - pre-fill basic info
              setAddress(prev => ({
                ...prev,
                full_name: data.user.name || patientDetails.name || '',
                phone: data.user.phone || patientDetails.phone || ''
              }));
              console.log(' Basic info pre-filled (no saved address)');
            }
          }
        } else {
          console.log(' User not found in database, using patient details only');
          // User not found - pre-fill from patient details only
          setAddress(prev => ({
            ...prev,
            full_name: patientDetails.name || '',
            email:patientDetails.email,
            phone: patientDetails.phone || ''
          }));
        }
      } catch (error) {
        console.error(' Error fetching address by phone:', error);
        // Fallback to patient details
        setAddress(prev => ({
          ...prev,
          full_name: patientDetails.name || '',
          phone: patientDetails.phone || ''
        }));
      }
    }
  };

  // Only run this when step changes to 'address' and we have patient details
  if (step === 'address' && patientDetails) {
    loadAddressFromPhone();
  }
}, [step, patientDetails]); 




    // Add this useEffect after the existing useEffects
    useEffect(() => {
      setDeliveryTimeSlots([]);
      setSelectedDeliveryTimeSlot('');
      
      if (deliveryTimeOption === 'specific' && selectedDateForSlot) {
        const slots = generateTimeSlotsForDate(selectedDateForSlot);
        setDeliveryTimeSlots(slots);
      }
    }, [deliveryTimeOption, selectedDateForSlot]);
    
    const roundUpToInterval = (date, intervalMinutes) => {
      const rounded = new Date(date);
      const minutes = rounded.getMinutes();
      const remainder = minutes % intervalMinutes;
      if (remainder !== 0) {
        rounded.setMinutes(minutes + (intervalMinutes - remainder));
      }
      rounded.setSeconds(0, 0);
      return rounded;
    };
    
    // Generate time slots for a specific date
    const generateTimeSlotsForDate = (dateString, config = DELIVERY_TIME_CONFIG) => {
      const slots = [];
      const now = new Date();
      const minDeliveryRaw = new Date(now.getTime() + config.minHoursFromNow * 60 * 60 * 1000);
      const minDeliveryTime = roundUpToInterval(minDeliveryRaw, config.timeSlotInterval);
      
      const parts = dateString.split('-');
      const year = parseInt(parts[0]);
      const month = parseInt(parts[1]);
      const day = parseInt(parts[2]);
      const selectedDate = new Date(year, month - 1, day, 0, 0, 0, 0);
    
      const nowDateStr = now.toDateString();
      const selectedDateStr = selectedDate.toDateString();
      const isToday = nowDateStr === selectedDateStr;
    
      for (let hour = config.availableHoursRange[0]; hour < config.availableHoursRange[1]; hour++) {
        for (let minute = 0; minute < 60; minute += config.timeSlotInterval) {
          const slotTime = new Date(year, month - 1, day, hour, minute, 0, 0);
          const slotTimestamp = slotTime.getTime();
          const minTimestamp = minDeliveryTime.getTime();
          
          const slotLabel = slotTime.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          });
    
          if (isToday) {
            const shouldSkip = slotTimestamp <= minTimestamp;
            if (shouldSkip) continue;
          }
    
          slots.push({
            value: slotTime.toISOString(),
            label: slotLabel,
            fullDate: slotTime
          });
        }
      }
    
      return slots;
    };
    
    // Generate available dates for next N days
    const generateAvailableDates = (daysAhead = 7) => {
      const dates = [];
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      
      for (let i = 0; i < daysAhead; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateValue = `${year}-${month}-${day}`;
        
        let label = date.toLocaleDateString('en-US', { 
          weekday: 'long',
          month: 'long', 
          day: 'numeric',
          year: 'numeric'
        });
        
        if (i === 0) {
          label = `Today - ${label}`;
        } else if (i === 1) {
          label = `Tomorrow - ${label}`;
        }
            
        dates.push({
          value: dateValue,
          label: label,
          fullDate: date
        });
      }
      
      return dates;
    };
    
    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
     
    
      if ( email && !emailRegex.test(email)) {
        return "Enter a valid email address";
      }
    
      return "";
    };
    

    const handlePatientDetailsComplete = (details) => {
      console.log('Patient Details:', details);
      setPatientDetails(details);
      setStep('upload');
    };
  
  
    const handleFileSelect = (event) => {
      const files = Array.from(event.target.files || []);
      if (files.length === 0) return;
  
      const validFiles = [];
      files.forEach(file => {
        const isValid = file.type.startsWith('image/') || 
                        file.type === 'application/pdf' ||
                        file.type.includes('word');
        if (isValid) validFiles.push(file);
      });
  
      if (validFiles.length === 0) {
        setDialog({ 
          open: true, 
          type: "error",
          title: "File Selection", 
          message: "Invalid file format. Please upload JPG, PNG, PDF, DOC, or DOCX files." 
        });
        return;
      }
  
      setUploading(true);
      
      const filePromises = validFiles.map(file => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({
              id: Date.now() + Math.random(),
              name: file.name,
              type: file.type,
              size: file.size,
              preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
              base64: reader.result,
              file: file // Keep original file for upload
            });
          };
          reader.readAsDataURL(file);
        });
      });
  
      Promise.all(filePromises).then(results => {
        setPrescriptionFiles(prev => [...prev, ...results]);
        setUploading(false);
      });
  
      event.target.value = '';
    };
  
    const handleRemoveFile = (fileId) => {
      setFileToRemove(fileId);
      setRemoveDialogOpen(true);
    };
  
    const confirmRemoveFile = () => {
      setPrescriptionFiles(prev => prev.filter(f => f.id !== fileToRemove));
      setRemoveDialogOpen(false);
      setFileToRemove(null);
    };
  
    const handleProceedToAddress = () => {
      if (prescriptionFiles.length === 0) {
        setDialog({ 
          open: true, 
          type: "warning",
          title: "Upload Required", 
          message: "Please upload at least one prescription file to continue." 
        });
        return;
      }
      setStep('address');
    };



    const handleSubmitOrder = async () => {
      if (!address.full_name || !address.phone || !address.community_name || 
          !address.address_line1 || !address.address_line2 ) {
        setDialog({ 
          open: true, 
          type: "warning",
          title: "Incomplete Address", 
          message: "Please fill all required fields to submit your order." 
        });
        return;
      }



// Validate delivery time if specific option is selected
if (deliveryTimeOption === "specific" && !selectedDeliveryTimeSlot) {
  setDialog({
    open: true,
    type: "warning",
    title: "Delivery Time Required",
    message: "Please select a delivery time slot to continue."
  });
  return;
}


      setLoading(true);
    
      try {
        const selectedSlot = deliveryTimeSlots.find(slot => slot.value === selectedDeliveryTimeSlot);
    
        const deliveryAddress = {
          ...address, 
          delivery_time_option: deliveryTimeOption,
          delivery_time: deliveryTimeOption === 'specific' && selectedSlot 
            ? selectedSlot.fullDate.toISOString()
            : 'Anytime',
          delivery_date: deliveryTimeOption === 'specific' && selectedSlot
            ? selectedSlot.fullDate.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })
            : '',
          delivery_time_label: deliveryTimeOption === 'specific' && selectedSlot
            ? selectedSlot.label
            : 'Anytime'
        };



        console.log(patientDetails)
        // Step 1: Create order first (without prescription URLs)
        const orderData = {
          user_email: patientDetails?.email || address.email,
          user_phone: patientDetails?.phone || address.phone,
          order_type: 'prescription',
          items: [],
          prescription_urls: [], // Empty initially
          delivery_address: deliveryAddress,
          subtotal: 0,
          delivery_charge: 0,
          discount: 0,
          total_amount: 0,
          patient_details: patientDetails,
          payment: {
            payment_id: `temp_${Date.now()}`,
            method: 'offline',
            status: 'pending',
            amount: 0
          },
          paymentDetails: {
            payment_id: `temp_${Date.now()}`,
            method: 'offline',
            status: 'pending',
            amount: 0
          },
          notes: `Prescription order - ${prescriptionFiles.length} file(s) uploaded`
        };
    
        console.log("Creating order...",orderData);
        const createdOrder = await createPrescriptionOrder(orderData);
        console.log("Order created:", createdOrder);
        console.log("Order ID:", createdOrder.order_id);
    
        // Step 2: Upload prescription files WITH the order ID
        console.log("Uploading prescriptions with order ID:", createdOrder.order_id);
        const prescriptionUrls = await uploadPrescriptionToServer(
          prescriptionFiles, 
          createdOrder.order_id  // ← PASS THE ORDER ID HERE
        );
        console.log("Prescription URLs:", prescriptionUrls);
    
        // Step 3: Update order with prescription URLs
        const updateResponse = await apiRequest(
          `${process.env.REACT_APP_MEDICINE_API_URL}/medicine-orders/${createdOrder.order_id}`,
          {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ prescription_urls: prescriptionUrls })
          }
        );
    
        if (!updateResponse.ok) {
          throw new Error('Failed to update order with prescription URLs');
        }
    
        const updatedOrder = await updateResponse.json();
        console.log("Updated order:", updatedOrder);
        
        setOrder(updatedOrder);
        setStep('confirmation');
        
        setDialog({ 
          open: true, 
          type: "success",
          title: "Order Submitted", 
          message: `Your order has been submitted successfully! Order ID: ${updatedOrder.order.order_id}` 
        });
    
      } catch (error) {
        setDialog({ 
          open: true, 
          type: "error",
          title: "Submission Failed", 
          message: error.message || "Failed to submit order. Please try again or contact support." 
        });
        console.error("Order submission error:", error);
      } finally {
        setLoading(false);
      }
    };
    const formatFileSize = (bytes) => {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };
  
    const getFileIcon = (type) => {
      if (type.startsWith('image/')) return '🖼️';
      if (type === 'application/pdf') return '📄';
      return '📝';
    };






  const steps = ['Patient Details', 'Upload Prescription', 'Delivery Address', 'Confirmation'];
  const getActiveStep = () => {
    switch(step) {
      case 'patient': return 0;
      case 'upload': return 1;
      case 'address': return 2;
      case 'confirmation': return 3;
      default: return 0;
    }
  };

  return (
    <>
      <Box sx={{ minHeight: '100vh', bgcolor: '#fafafa', pb: 10 }}>
        <AppBar position="static" sx={{ bgcolor: '#006D77', color: '#fff' }}>
          <Container maxWidth="md">
            <Box sx={{ py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton onClick={() => {
                if (step === 'upload') setStep('patient');
                else if (step === 'address') setStep('upload');
                else if (step === 'confirmation') setStep('address');
                else window.history.back();
              }} sx={{ color: '#fff' }}>
                <ArrowBack />
              </IconButton>
              <Typography variant="h6" fontWeight="600">
                Prescription Order
              </Typography>
            </Box>
          </Container>
        </AppBar>

        <Container maxWidth="md" sx={{ mt: 3 }}>
          {/* Progress Stepper */}
          <Paper sx={{ p: 3, mb: 3 }}>
            <Stepper activeStep={getActiveStep()} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Paper>

          {/* STEP 1: Patient Details */}
          {step === 'patient' && (
            <PatientDetailsForm
              onComplete={handlePatientDetailsComplete}
              initialData={patientDetails}
              userEmail={user?.email}
              orderType="prescription"
            />
          )}


     
          {/* STEP 2: Upload Prescription */}
          {step === 'upload' && (
            <Box sx={{ minHeight: "100vh", bgcolor: "#F7F8FA", py: 10 }}>
                       {patientDetails && (
                <Card sx={{ mb: 3, bgcolor: '#E0F7FA' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Person sx={{ fontSize: 40, color: '#006D77' }} />
                      <Box>
                        <Typography variant="h6" fontWeight={600}>
                          {patientDetails.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Age: {patientDetails.dob} | Gender: {patientDetails.gender} | Phone: {patientDetails.phone}
                        </Typography>
                        {patientDetails.doctorname && (
                          <Typography variant="body2" color="text.secondary">
                            Doctor: {patientDetails.doctorname}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              )}

              <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} md={8}>
                  {/* Upload Card */}
                  <Card sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 4,
                    p: 3,
                    borderRadius: "16px",
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                    border: "1px solid #E5E7EB",
                    width: "100%",
                    backgroundColor: "#fff",
                    mb: 4,
                  }}>
                    <Box component="img" src={uploadPrescription} alt="Upload Prescription"
                      sx={{ width: 350, height: 300, objectFit: "contain", borderRadius: "12px" }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h5" fontWeight={700} color="#153f4b" mb={1}>
                        Upload Your Prescription
                      </Typography>
                      <Typography variant="body2" color="#4B5563" mb={2}>
                        Upload images, PDFs, or documents. Our pharmacist will verify and arrange the medicines for you.
                      </Typography>
                      <Box sx={{ display: "flex", gap: 2, mb: 5 }}>
                        <Button variant="contained" component="label" startIcon={<PhotoLibrary />}
                          sx={{
                            bgcolor: "#22577A",
                            textTransform: "none",
                            fontWeight: 600,
                            marginTop: "50px",
                            "&:hover": { bgcolor: "#1a4a66" },
                          }}>
                          Choose from gallery
                          <input type="file" accept="image/*,.pdf,.doc,.docx" hidden multiple onChange={handleFileSelect} />
                        </Button>
                      </Box>
                      <Typography variant="caption"
                        sx={{ bgcolor: "#E8F8E1", px: 1.5, py: 0.5, borderRadius: "8px", fontWeight: 500 }}>
                        Supported formats: JPG, PNG, PDF, DOC, DOCX
                      </Typography>
                    </Box>
                  </Card>

                  {/* Uploaded Files */}
                  {uploading && (
                    <Box sx={{ textAlign: "center", py: 2 }}>
                      <CircularProgress size={40} />
                    </Box>
                  )}

                  {prescriptionFiles.length > 0 && (
                    <Card sx={{ mb: 3 }}>
                      <Box sx={{ p: 3 }}>
                        <Typography variant="h6" fontWeight={600} mb={2}>
                          Uploaded Files ({prescriptionFiles.length})
                        </Typography>
                        <Grid container spacing={2}>
                          {prescriptionFiles.map((file) => (
                            <Grid item xs={12} key={file.id}>
                              <Paper elevation={1} sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
                                {file.preview ? (
                                  <Box component="img" src={file.preview} alt={file.name}
                                    sx={{ width: 80, height: 80, objectFit: "cover", borderRadius: 1, border: "1px solid #ddd" }} />
                                ) : (
                                  <Box sx={{
                                    width: 80, height: 80, display: "flex", alignItems: "center",
                                    justifyContent: "center", bgcolor: "#f5f5f5", borderRadius: 1
                                  }}>
                                    <Typography sx={{ fontSize: 40 }}>{getFileIcon(file.type)}</Typography>
                                  </Box>
                                )}
                                <Box sx={{ flex: 1 }}>
                                  <Typography variant="body2" fontWeight={600} noWrap>{file.name}</Typography>
                                  <Typography variant="caption" color="text.secondary">{formatFileSize(file.size)}</Typography>
                                </Box>
                                <IconButton onClick={() => handleRemoveFile(file.id)} color="error">
                                  <Close />
                                </IconButton>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </Card>
                  )}

                  {/* Guidelines Card */}
                  <Card sx={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    p: 3, borderRadius: "16px", width: "100%", height: '280px',
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)", border: "1px solid #E5E7EB",
                    backgroundColor: "#fff", mb: 4
                  }}>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h5" fontWeight={700} color="#153f4b" mb={1.5}>
                        Prescription Guidelines
                      </Typography>
                      {[
                        "Ensure prescription is clear and readable",
                        "Include doctor's name & signature",
                        "Prescription should be valid (not expired)",
                        "All corners should be visible",
                        "Multiple pages can be uploaded",
                      ].map((text, index) => (
                        <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 1.8 }}>
                          <CheckCircle sx={{ fontSize: 20, color: "#22577A", mr: 1 }} />
                          <Typography variant="body2" color="#374151" sx={{ fontSize: "16px", fontWeight: 500 }}>
                            {text}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                    <Box component="img" src={uploadGuidelines} alt="Guidelines Illustration"
                      sx={{ width: 450, height: 300, objectFit: "contain" }} />
                  </Card>

                  {/* Payment Method Card */}
                  <Card sx={{
                    display: "flex", alignItems: "flex-start", justifyContent: "space-between",
                    p: 3, borderRadius: "16px", width: "100%", height: '280px',
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.1)", border: "1px solid #E5E7EB",
                    backgroundColor: "#fff"
                  }}>
                    <Box component="img" src={paymentMethod} alt="Payment Illustration"
                      sx={{ width: 350, height: 280, objectFit: "contain" }} />
                    <Box sx={{ flex: 1, ml: 3 }}>
                      <Typography variant="h6" fontWeight={700} color="#153f4b" mb={1}>
                        Payment Method
                      </Typography>
                      <Typography variant="body2" color="#374151">
                        This order will be processed as <strong>Cash on Delivery (COD)</strong>
                      </Typography>
                      <Typography variant="body2" color="#6B7280">
                        Pay when your medicines are delivered to your doorstep.
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          )}

        


        {step === 'address' && (
          <Box sx={{ maxWidth: '900px', mx: 'auto', px: 2 }}>
            {/* Patient Details Summary - Compact Card */}
            {patientDetails && (
              <Card elevation={0} sx={{ mb: 3,borderRadius: 2,border: '1px solid #e0f2f1',bgcolor: '#f0fdfa'}}>
                <CardContent sx={{ p: 2.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{width: 48,height: 48,borderRadius: '50%',bgcolor: '#006D77',display: 'flex',alignItems: 'center',justifyContent: 'center',color: '#fff',fontSize: 20,fontWeight: 700,flexShrink: 0
                    }}>
                      {patientDetails.name?.charAt(0) || 'P'}
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="subtitle1" fontWeight={700} color="#0f172a" noWrap>
                        {patientDetails.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {patientDetails.dob} yrs • {patientDetails.gender} • {patientDetails.phone}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            )}

            {/* Main Delivery Form */}
            <Card  elevation={0} sx={{  borderRadius: 2, border: '1px solid #e0e0e0', bgcolor: '#fff'}} >
              <CardContent sx={{ p: 4 }}>
                {/* Form Title */}
                <Typography variant="h5" fontWeight={700} color="#1f2937" sx={{ mb: 1 }}>
                  Delivery Information
                </Typography>

                <Grid container spacing={2} direction="column">
                  {/* Full Name */}
                  <Grid item xs={12}>
                    <TextField 
                      label="Full Name" 
                      fullWidth 
                      required
                      value={address.full_name}
                      onChange={(e) => setAddress({ ...address, full_name: e.target.value })}
                      placeholder="Full Name"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#fafafa',
                          '& fieldset': {
                            borderColor: '#e0e0e0',
                          },
                          '&:hover fieldset': {
                            borderColor: '#bdbdbd',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#006D77',
                          }
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
              <TextField
                // label="Email"
                fullWidth
                required
                value={address.email}
                onChange={(e) => {
                  const value = e.target.value;
                  setAddress({ ...address, email: value });
                  setEmailError(validateEmail(value));
                }}
                error={Boolean(emailError)}
                helperText={emailError}
                placeholder="Email*"
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: '#fafafa',
                    '& fieldset': {
                      borderColor: '#e0e0e0',
                    },
                    '&:hover fieldset': {
                      borderColor: '#bdbdbd',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#006D77',
                    }
                  }
                }}
              />
            </Grid>
                  {/* Phone Number */}
                  <Grid item xs={12}>
                    <TextField 
                      label="Phone" 
                      fullWidth 
                      required
                      value={address.phone}
                      onChange={(e) => setAddress({ ...address, phone: e.target.value })}
                      placeholder="Phone"
                      inputProps={{ maxLength: 10 }}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#fafafa',
                          '& fieldset': {
                            borderColor: '#e0e0e0',
                          },
                          '&:hover fieldset': {
                            borderColor: '#bdbdbd',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#006D77',
                          }
                        }
                      }}
                    />
                  </Grid>

                  {/* Community/Society Name */}
                  <Grid item xs={12}>
                    <TextField 
                      select 
                      label="Community/Society Name" 
                      fullWidth 
                      required
                      value={address.community_name}
                      onChange={(e) => setAddress({ ...address, community_name: e.target.value })}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#fafafa',
                          '& fieldset': {
                            borderColor: '#e0e0e0',
                          },
                          '&:hover fieldset': {
                            borderColor: '#bdbdbd',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#006D77',
                          }
                        }
                      }}
                    >
                      <MenuItem value="" disabled>
                        Community/Society Name
                      </MenuItem>
                      {COMMUNITY_OPTIONS.map((community) => (
                        <MenuItem key={community} value={community}>
                          {community}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Block/Building */}
                  <Grid item xs={12}>
                    <TextField 
                      select 
                      label="Block/Building" 
                      fullWidth 
                      required
                      value={address.address_line1}
                      onChange={(e) => setAddress({ ...address, address_line1: e.target.value })}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#fafafa',
                          '& fieldset': {
                            borderColor: '#e0e0e0',
                          },
                          '&:hover fieldset': {
                            borderColor: '#bdbdbd',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#006D77',
                          }
                        }
                      }}
                    >
                      <MenuItem value="" disabled>
                        Block/Building
                      </MenuItem>
                      {BLOCK_OPTIONS.map((block) => (
                        <MenuItem key={block} value={block}>
                          {block}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Flat/Apartment Number */}
                  <Grid item xs={12}>
                    <TextField 
                      label="Flat/Apartment Number*" 
                      fullWidth
                      value={address.address_line2}
                      onChange={(e) => setAddress({ ...address, address_line2: e.target.value })}
                      placeholder="Flat/Apartment Number*"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#fafafa',
                          '& fieldset': {
                            borderColor: '#e0e0e0',
                          },
                          '&:hover fieldset': {
                            borderColor: '#bdbdbd',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#006D77',
                          }
                        }
                      }}
                    />
                  </Grid>

                  {/* Delivery Preference */}
                  <Grid item xs={12}>
                    <TextField 
                      select
                      label="Delivery Preference" 
                      fullWidth 
                      required
                      value={deliveryTimeOption}
                      onChange={(e) => {
                        setDeliveryTimeOption(e.target.value);
                        setSelectedDateForSlot('');
                        setSelectedDeliveryTimeSlot('');
                        setDeliveryTimeSlots([]);
                      }}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#fafafa',
                          '& fieldset': {
                            borderColor: '#e0e0e0',
                          },
                          '&:hover fieldset': {
                            borderColor: '#bdbdbd',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#006D77',
                          }
                        }
                      }}
                    >
                      <MenuItem value="anytime">Anytime (6 AM - 10 PM)</MenuItem>
                      <MenuItem value="specific">Schedule Specific Time</MenuItem>
                    </TextField>
                  </Grid>

                  {/* Flexible Delivery Info */}
                  {deliveryTimeOption === 'anytime' && (
                    <Grid item xs={12}>
                      <Alert 
                        severity="success" 
                        icon={<Box sx={{ fontSize: 20 }}>✓</Box>}
                        sx={{ 
                          bgcolor: '#d1fae5',
                          border: 'none',
                          borderRadius: 1.5,
                          '& .MuiAlert-message': {
                            color: '#065f46',
                            fontSize: 14
                          }
                        }}
                      >
                        Your order will be delivered anytime between 6 AM - 10 PM. Our delivery partner will contact you before arrival.
                      </Alert>
                    </Grid>
                  )}

                  {/* Date Selection */}
                  {deliveryTimeOption === 'specific' && (
                    <Grid item xs={12}>
                      <TextField 
                        select
                        label="Select Date" 
                        fullWidth 
                        required
                        value={selectedDateForSlot}
                        onChange={(e) => {
                          setDeliveryTimeSlots([]);
                          setSelectedDeliveryTimeSlot('');
                          setSelectedDateForSlot(e.target.value);
                        }}
                        variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            bgcolor: '#fafafa',
                            '& fieldset': {
                              borderColor: '#e0e0e0',
                            },
                            '&:hover fieldset': {
                              borderColor: '#bdbdbd',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#006D77',
                            }
                          }
                        }}
                      >
                        <MenuItem value="" disabled>Select Date</MenuItem>
                        {generateAvailableDates().map((date) => (
                          <MenuItem key={date.value} value={date.value}>
                            {date.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  )}

                  {/* Time Slot Selection */}
                  {deliveryTimeOption === 'specific' && selectedDateForSlot && deliveryTimeSlots.length > 0 && (
                    <Grid item xs={12}>
                      <TextField 
                        select
                        label="Select Time Slot" 
                        fullWidth 
                        required
                        value={selectedDeliveryTimeSlot}
                        onChange={(e) => setSelectedDeliveryTimeSlot(e.target.value)}
                        variant="outlined"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            bgcolor: '#fafafa',
                            '& fieldset': {
                              borderColor: '#e0e0e0',
                            },
                            '&:hover fieldset': {
                              borderColor: '#bdbdbd',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#006D77',
                            }
                          }
                        }}
                      >
                        <MenuItem value="" disabled>Select Time Slot</MenuItem>
                        {deliveryTimeSlots.map((slot) => (
                          <MenuItem key={slot.value} value={slot.value}>
                            {slot.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  )}

                  {/* No Slots Warning */}
                  {deliveryTimeOption === 'specific' && selectedDateForSlot && deliveryTimeSlots.length === 0 && (
                    <Grid item xs={12}>
                      <Alert 
                        severity="warning" 
                        sx={{ 
                          bgcolor: '#fef3c7',
                          border: 'none',
                          borderRadius: 1.5,
                          '& .MuiAlert-message': {
                            color: '#92400e',
                            fontSize: 14
                          }
                        }}
                      >
                        No available slots for this date. Please select another date.
                      </Alert>
                    </Grid>
                  )}

                  {/* Delivery Scheduled Success */}
                  {deliveryTimeOption === 'specific' && selectedDeliveryTimeSlot && (
                    <Grid item xs={12}>
                      <Alert 
                        severity="success" 
                        icon={<Box sx={{ fontSize: 20 }}>✓</Box>}
                        sx={{ 
                          bgcolor: '#d1fae5',
                          border: 'none',
                          borderRadius: 1.5,
                          '& .MuiAlert-message': {
                            color: '#065f46'
                          }
                        }}
                      >
                        <Box>
                          <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
                            Delivery scheduled successfully
                          </Typography>
                          <Typography variant="body2" fontWeight={700} sx={{ fontSize: 15 }}>
                            {new Date(selectedDeliveryTimeSlot).toLocaleDateString('en-US', {
                              weekday: 'long',
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })}
                          </Typography>
                          <Typography variant="body2" fontWeight={600} sx={{ mt: 0.5 }}>
                            at {new Date(selectedDeliveryTimeSlot).toLocaleTimeString('en-US', {
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </Typography>
                        </Box>
                      </Alert>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Box>
        )}




          {/* STEP 3: Order Confirmation */}
          {step === 'confirmation' && order && (
            <>
              <Alert severity="success" sx={{ mb: 3 }}>
                <Typography variant="body2" fontWeight="600">Order Submitted Successfully!</Typography>
                <Typography variant="caption">Order ID: {order.order_id}</Typography>
              </Alert>
              <Card sx={{ mb: 3 }}>
                <CardContent>
                  <Typography variant="h6" fontWeight="600" mb={2}>Order Status</Typography>
                  <Chip label="Waiting for Admin Review" color="warning" icon={<LocalHospital />} sx={{ mb: 2 }} />
                  <Typography variant="body2" color="text.secondary">
                    Our pharmacist will review your prescription and calculate the bill. 
                    You'll receive a notification once the bill is ready.
                  </Typography>
                </CardContent>
              </Card>
              <Card sx={{ mb: 3 }}>
                <CardContent>
                  <Typography variant="h6" fontWeight="600" mb={2}>Prescription Files</Typography>
                  <Typography variant="body2" mb={2}>{prescriptionFiles.length} file(s) uploaded</Typography>
                  
                  {/* Display uploaded prescription images/files */}
                  {order.prescription_urls && order.prescription_urls.length > 0 && (
                    <Grid container spacing={2}>
                      {order.prescription_urls.map((url, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                          <Paper elevation={2} sx={{ p: 1 }}>
                            <Box
                              component="img"
                              src={`${process.env.REACT_APP_MEDICINE_API_URL}${url}`}
                              alt={`Prescription ${index + 1}`}
                              sx={{
                                width: '100%',
                                height: 200,
                                objectFit: 'contain',
                                borderRadius: 1,
                                cursor: 'pointer'
                              }}
                              onClick={() => window.open(`${process.env.REACT_APP_MEDICINE_API_URL}${url}`, '_blank')}
                            />
                            <Typography variant="caption" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
                              Prescription {index + 1}
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </CardContent>
              </Card>
              <Card>
                <CardContent>
                  <Typography variant="h6" fontWeight="600" mb={2}>Delivery Address</Typography>
                  <Typography variant="body2"><strong>Name:   </strong>{address.full_name}</Typography>
                  <Typography variant="body2"><strong>Email:   </strong>{address.email}</Typography>
                  <Typography variant="body2"><strong>Phone:  </strong>{address.phone}</Typography>
                  <Typography variant="body2"><strong>Block:  </strong>{address.address_line1}</Typography>
                  <Typography variant="body2"><strong>Flat No:  </strong>{address.address_line2}</Typography>
                  {/* <Typography variant="body2">{address.city}, {address.state} - {address.pincode}</Typography> */}
                </CardContent>
              </Card>
            </>
          )}
        </Container>

        {/* Bottom Action Button */}
        <Box sx={{
          position: 'fixed', bottom: 0, left: 0, right: 0,
          bgcolor: '#fff', borderTop: 1, borderColor: 'divider', p: 2
        }}>
          <Container maxWidth="md">
            {step === 'upload' && (
              <Button variant="contained" size="large" fullWidth
                disabled={prescriptionFiles.length === 0 || uploading}
                onClick={handleProceedToAddress}
                sx={{
                  bgcolor: '#006D77', py: 1.5, textTransform: 'none',
                  fontSize: 16, fontWeight: 600, '&:hover': { bgcolor: '#005560' }
                }}>
                Proceed to Address
              </Button>
            )}
            {step === 'address' && (
              <Button variant="contained" size="large" fullWidth disabled={loading}
                onClick={handleSubmitOrder}
                sx={{
                  bgcolor: '#006D77', py: 1.5, textTransform: 'none',
                  fontSize: 16, fontWeight: 600, '&:hover': { bgcolor: '#005560' }
                }}>
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Order'}
              </Button>
            )}
            {step === 'confirmation' && (
              <Button variant="contained" size="large" fullWidth
                onClick={() => window.location.href = '/orders-management'}
                sx={{
                  bgcolor: '#006D77', py: 1.5, textTransform: 'none',
                  fontSize: 16, fontWeight: 600, '&:hover': { bgcolor: '#005560' }
                }}>
                View Orders
              </Button>
            )}
          </Container>
        </Box>

        {/* Remove File Dialog */}
        <Dialog open={removeDialogOpen} onClose={() => setRemoveDialogOpen(false)}>
          <DialogTitle>Remove File</DialogTitle>
          <DialogContent>
            <Typography>Remove this file?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setRemoveDialogOpen(false)}>Cancel</Button>
            <Button onClick={confirmRemoveFile} color="error" variant="contained">Remove</Button>
          </DialogActions>
        </Dialog>
      </Box>

      {/* CustomDialog - Outside the main Box */}
      <CustomDialog
        open={dialog.open}
        title={dialog.title}
        message={dialog.message}
        type={dialog.type}
        onClose={() => setDialog({ ...dialog, open: false })}
      />
    </>
  );
};

export default PrescriptionUploadScreen;